<template>
  <section>
    <h2>
      <i18n path="common.install" />
    </h2>

    <div>
      <i18n path="common.guide.useNpm" />
    </div>
    <showcode :trigger="false">
      <pre class="m-0">npm i -S v-region</pre>
    </showcode>

    <div>
      <i18n path="common.guide.include" />
    </div>
    <showcode :trigger="false">
      <v-code lang="javascript">
        <pre>
        import Vue from 'vue'
        import Region from 'v-region'
        /**
         * Globally register region components
         * v-region-group
         * v-region-selects
         * v-region-columns
         * v-region-city-picker
         * v-region-text
         */
        Vue.use(Region)
        </pre>
      </v-code>
    </showcode>

    <div>
      <i18n path="common.guide.customRegister" />
    </div>
    <showcode :trigger="false">
      <v-code lang="javascript">
        <pre>
        import Vue from 'vue'
        import { RegionSelects } from 'v-region'
        Vue.component('v-region-selects', RegionSelects)
        </pre>
      </v-code>
    </showcode>

    <h2 class="mt-5">
      <i18n path="common.deploy" />
    </h2>

    <div>
      <i18n path="common.guide.useGlobalComponent" />
    </div>
    <showcode :trigger="false">
      <v-code>
        <pre>
        &lt;template&gt;
          &lt;v-region-selects @change="regionChange" /&gt;
        &lt;/template&gt;

        &lt;script&gt;
        export default {
          methods: {
            // Responding to data changes
            regionChange (data) {
              console.log(data)
            }
          }
        }
        &lt;/script&gt;
        </pre>
      </v-code>
    </showcode>

    <div>
      <i18n path="common.guide.useLocalComponent" />
    </div>
    <showcode :trigger="false">
      <v-code>
        <pre>
        &lt;template&gt;
          &lt;region-selects @change="regionChange" /&gt;
        &lt;/template&gt;

        &lt;script&gt;
        import { RegionSelects } from 'v-region'

        export default {
          components: {
            RegionSelects
          },
          methods: {
            // Responding to data changes
            regionChange (data) {
              console.log(data)
            }
          }
        }
        &lt;/script&gt;
        </pre>
      </v-code>
    </showcode>
  </section>
</template>

<script>
export default {

}
</script>
